module.exports = __webpack_public_path__ + "static/media/20900025-F6f1wSgs.47f1a6f8.JPG";